export const video = () => (
  <path
    d="M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
